var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'p-3 border-l-4 rounded bg-gray-200 text-sm': true,
    'bg-primary-light border-primary-dark text-primary-dark': _vm.primary,
    'bg-green-300 border-green-700 text-green-700': _vm.success,
    'bg-red-300 border-red-700 text-red-700': _vm.error,
    'bg-blue-300 border-blue-700 text-blue-700': _vm.info
  }},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }